export default {
  computed: {
    modules () {
      return Drupal.t('modules', {}, {context: "products_category"})
    },
    ebooks () {
      return Drupal.t('e-books', {}, {context: "products_category"})
    }
  }
}
